import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button.tsx";

const UpdatesSettings: React.FC = () => {
	const [status, setStatus] = useState("");
	const [updateReady, setUpdateReady] = useState(false);

	useEffect(() => {
		navigator.serviceWorker
			?.getRegistration()
			.then((registration) => setUpdateReady(!!registration?.waiting));
	}, []);

	const checkForUpdate = async () => {
		const registration = await navigator.serviceWorker?.getRegistration();
		if (!registration) {
			setStatus("No service worker registered.");
			return;
		}
		setStatus("Checking…");
		await registration.update();
		// ponytail: install is async; give the new worker a moment to reach the waiting state
		await new Promise((r) => setTimeout(r, 1000));
		setUpdateReady(!!registration.waiting);
		setStatus(
			registration.waiting
				? "Update available."
				: "You're already on the latest version.",
		);
	};

	const applyUpdate = async () => {
		const registration = await navigator.serviceWorker?.getRegistration();
		const waiting = registration?.waiting;
		if (!waiting) {
			setUpdateReady(false);
			setStatus("You're already on the latest version.");
			return;
		}
		navigator.serviceWorker.addEventListener(
			"controllerchange",
			() => window.location.reload(),
			{ once: true },
		);
		waiting.postMessage({ type: "SKIP_WAITING" });
	};

	return (
		<div className={"w-full"}>
			<div className={"flex flex-col p-4 w-full border-b"}>
				<div className={"flex justify-between items-center w-full"}>
					<h2>App updates</h2>
					<div className={"flex gap-2"}>
						<Button variant={"outline"} onClick={checkForUpdate}>
							Check for updates
						</Button>
						<Button
							variant={"default"}
							disabled={!updateReady}
							onClick={applyUpdate}
						>
							Update
						</Button>
					</div>
				</div>
				{status && (
					<p className={"text-slate-500 mt-2"}>{status}</p>
				)}
			</div>
		</div>
	);
};

export { UpdatesSettings };
